import type { GetConnectedIntegrationsResponse } from '@vy/api-definition';
import type { IntegrationProviders } from '@vy/types';
import type { Nullable } from '@vy/utils';
import { isNotNullOrUndefined } from '@vy/utils';
import type { CustomUseQueryOptions } from './requests/requests-types/custom-use-query-options';
import { useConnectedIntegrations } from './requests/use-integrations';

export function useActivatedIntegration(
  provider: Nullable<IntegrationProviders>,
  options?: CustomUseQueryOptions<GetConnectedIntegrationsResponse>,
) {
  const { data: connectedIntegrations } = useConnectedIntegrations(options);

  return (
    isNotNullOrUndefined(connectedIntegrations) &&
    isNotNullOrUndefined(provider) &&
    connectedIntegrations.includes(provider)
  );
}
